// extracted by mini-css-extract-plugin
export default {"avatar":"AiAgentAvatar_avatar__SD2YC","icon":"AiAgentAvatar_icon__fkJBA","pulse":"AiAgentAvatar_pulse__6I8Yo","ai-avatar-pulse":"AiAgentAvatar_ai-avatar-pulse__bu3mb"};